import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../App.css";

const VerifyAccount = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const email = searchParams.get("email");
        const token = searchParams.get("token");

        if (!email || !token) {
          throw new Error("Invalid verification link");
        }

        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/api/auth/verify-account?email=${email}&token=${token}`
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Verification failed");
        }

        setStatus("success");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } catch (err) {
        setStatus("error");
        setError(err.message);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="verification-container">
      <div className="verification-card">
        {status === "verifying" && (
          <>
            <div className="loading-animation">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
            </div>
            <h2>Verifying Your Email</h2>
            <p>Please wait while we verify your email address...</p>
          </>
        )}

        {status === "success" && (
          <div className="success-animation">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark-circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark-check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
                stroke="white"
                strokeWidth="5"
              />
            </svg>
            <h2>Email Verified Successfully!</h2>
            <p>Redirecting you to login page...</p>
          </div>
        )}

        {status === "error" && (
          <div className="error-animation">
            <div className="error-icon">
              <span>!</span>
            </div>
            <h2>Verification Failed</h2>
            <p className="error-message">{error}</p>
            <p className="support-text">
              Please contact our support team at:
              <a href="mailto:support@grademe-ai.com">support@grademe-ai.com</a>
            </p>
            <button
              className="retry-button"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
            <button
              className="retry-button"
              onClick={() => navigate("/login")}
              style={{ marginLeft: "10px" }}
            >
              Return to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyAccount;
